<template>
  <div class="page flex-col">
    <div class="group_2 flex-col">
      <van-divider
        :style="{ color: '#fa8a19', borderColor: '#fa8a19', padding: '0 16px' }">个人预约信息</van-divider
      >
      <van-tabs v-model:active="active">
        <van-tab title="登陆预约">
          <van-form>
            <br/>
            <van-cell-group inset>
              <van-field
                v-model="registerData.realName"
                required
                label="真实姓名"
                :rules="[{ required: true, message: '请填写姓名' }]"
              />
              <van-field
                v-model="registerData.phone"
                required
                label="手机号码"
                :rules="[
                  { required: true },
                  {
                    pattern: /^1[3456789]\d{9}$/,
                    message: '手机号码格式错误！',
                  },
                ]"
              />
              <van-field
                  v-model="registerData.smsBindingCode"
                  center
                  required
                  clearable
                  label="短信验证码"
                   placeholder="请输入验证码"
              >
              <template #button>
                  <van-button size="small" type="primary" @click="sendSms">发送验证码</van-button>
              </template>
            </van-field>
            </van-cell-group>
          </van-form>
          <div style="margin: 16px">
            <van-button
              round
              block
              color="linear-gradient(to right, #f67f34, #d55809)"
              native-type="submit"
              @click="getData">确认提交</van-button>
          </div>
          <span class="text_3"></span>
      <div class="image-text_1 flex-col">
        <span class="text-group_1"></span>
      </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import { ref, toRefs, reactive, onMounted } from "vue";
import { postSaveMobile } from "../../api/register";
import { useRouter } from "vue-router";
import { showDialog } from "vant";
export default {
  setup() {
    const showBinging = ref(false);
    const activeAll = ref(0);
    const active = ref(0);
    const router = useRouter();
    const axios = require("axios")
    const kpianawait = reactive({
      cellGroupBackground: "#F1F1F1",
    });
    const state = reactive({
      registerData: {
        realName: "",
        phone: "",
        smsBindingCode: "",
        informed: "",
      },
    });
    const hosp = reactive({
      HospInfo: {
        hospId: "",
      },
    });
    const getData = () => {
      if (state.registerData.realName == null || state.registerData.phone ==null) {
        showDialog({
            title: "错误提醒",
            message: "请填写必要的绑定信息!",
            theme: "round-button",
          }).then(() => {
            
          });
      } else {
        postSaveMobile(state.registerData).then((res) => {
          console.log(res.data.code);
          if (res.data.code == 20000) {
            console.log("绑定成功");
            router.push('binding');
          } else {
            console.log("绑定失败，失败原因:" + res.data.message);
          }
        });
      }
    };
    const sendSms = () => {
      if (state.registerData.realName == null || state.registerData.phone ==null) {
        showDialog({
            title: "错误提醒",
            message: "请填写必要的绑定信息!",
            theme: "round-button",
          }).then(() => {
            
          });
      } else {
        axios
          .get("http://global-bplan.net/wxmanager/pushSmsCodeByMobile", {
           params: {
            mobile: state.registerData.phone
           }
        })
        .then(function (response) {
           console.log(response)
           if(response.data.code == 0){
              showDialog({
                title: "发送成功",
                message: "短信验证码发送成功!",
                theme: "round-button",
                }).then(() => {
            
              });
           }else{
            showDialog({
                title: "发送失败",
                message: "短信验证码发送失败，请稍后重试!",
                theme: "round-button",
                }).then(() => {
            
              });
           }
        })
      .catch(function (error) {
        console.log(error)
        showDialog({
                title: "发送失败",
                message: "短信验证码发送失败，请稍后重试!",
                theme: "round-button",
                }).then(() => {
            
              });
        })
      .finally(function () {
          // 总是会执行
        })
      }
    };
    onMounted(() => {
      console.log("页面打开");
    });
    return {
      hosp,
      kpianawait,
      ...toRefs(state),
      getData,
      showBinging,
      activeAll,
      active,
      sendSms,
   
    };
  },
};
</script>
<style scoped lang="css" src="./assets/index.css" />
